export function compareAttributes(left, right) {
  let count = 0;
  for (const key in left) {
    count++;
    if (left[key] !== right[key]) {
      return false;
    }
  }
  let otherCount = 0;
  for (const key in right) {
    otherCount++;
  }
  return count === otherCount;
}
